<template>
  <div class="ly_match_create">
    <div class="hd">
      <h2 class="tit">경기 만들기</h2>
      <a class="btn_close" href="javascript:;" @click="closeCreate">닫기</a>
      <ul class="option">
        <li><a href="javascript:;" :class="{selected:gameType === 'pre'}" @click="typeSelect('pre')">예정된 경기</a></li>
        <li><a href="javascript:;" :class="{selected:gameType === 'live'}" @click="typeSelect('live')">라이브 경기</a></li>
      </ul>
    </div>
    <div class="bd">
      <ul class="game_tab">
        <li v-for="(item, key) in sportsCategory" :key="key">
          <a :class="[ item.class, {selected:sportsId === item.id}]" href="javascript:;" @click="getList(item.id, item.text)" v-if="item.id">
            {{ item.text }}</a>
        </li>
      </ul>

      <div class="match_list">
        <div class="inner">
          <div class="item" v-for="(sports, lmn) in list" :key="lmn">
            <div class="league"><div class="tit">{{ lmn }}</div></div>
            <div class="team" :class="{selected:item.isMarkets}" v-for="(item, key) in sports" :key="key">
              <a class="info" href="javascript:;"  @click="openMarketList(item.matchid)">
                <div class="time">{{ item.matchdate }}</div>
                <div class="name">
                  <span class="left">{{ item.hTeamNm }}</span>
                  <span class="vs">vs</span>
                  <span class="right">{{ item.aTeamNm }}</span>
                </div>
                <span class="ic_more">더보기</span>
              </a>
              <div class="detail" v-show="item.isMarkets">
                <dl v-for="(val, mnm) in item.markets" :key="index">
                  <dt>{{ mnm }}</dt>
                  <dd v-for="(data, i) in val" :key="key">
                    <a :class="{selected:outcome.outcomeid === data.outcomeid}" href="javascript:;"
                       @click="selectPick(data)">
                      <span class="tx">
                        <template v-if="lang[data.kind]">{{ lang[data.kind] }}</template>
                        <template v-else-if="data.order === 1">{{ item.hTeamNm }}</template>
                        <template v-else-if="data.order === 2">{{ item.aTeamNm }}</template>
                        {{ data.dPoint }}
                      </span>
                      <span class="odd">{{ data.price }}</span>
                    </a>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="no_history" v-if="Object.keys(list).length <= 0 && loaded">진행중인 게임이 없습니다. </div>
        </div>
      </div>
      <div class="btn_area">
        <a class="_btn btn_next active" href="javascript:;" @click="openBetSlip">다음 단계</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "match-create",
    data() {
      let gameType = this.$route.query.gameType ? this.$route.query.gameType : 'pre'
      gameType = (gameType === 'all') ? 'pre' : gameType
      return {
        sportsId: 1,
        outcome: '',
        gameType: gameType,
        list:{},
        loaded:false
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList(id, subject) {
        subject && gaEventer(`예측배틀 - 게임 만들기 ${this.statusList[this.gameType]} 종목`, subject)
        this.loaded = false
        this.sportsId = id ? id : this.sportsId;
        const res = await this._get("/v1/match", this.condition);
        this.list = _.reduce(res.data.data, (result, row, key) => {
          if (!result[row['lnm']]) {
            result[row['lnm']] = [];
          }
          row['isMarkets'] = false;
          result[row['lnm']].push(row);
          return result;
        }, {});
        this.$store.dispatch('match/addMatchList', res.data.data);
        this.loaded = true

      },
      typeSelect(gameType) {
        gaEventer('예측배틀 - 게임 만들기 타입', this.statusList[gameType])
        this.gameType = gameType;
        this.getList();
      },
      closeCreate() {
        this.$store.dispatch('match/closeCreate');
      },
      openBetSlip() {
        if (!this.outcome) {
          alert('경기를 선택하세요.');
          return;
        }
        gaEventer('예측배틀 - 게임 만들기', '다음 단계')

        this.$store.dispatch('match/openBetSlip', Object.assign({
          sportsId : this.sportsId,
          gameType : this.gameType
        }, this.outcome));
      },

      async openMarketList(matchId){

        const res = await this._get("/v1/market", {
          matchId : matchId
        });

        this.$store.dispatch('match/openMarketList', {
          matchId : matchId,
          markets : res.data.markets
        });

      },
      selectPick(outcome) {
        this.outcome = outcome
      },
    },
    computed: {
      condition() {
        return {
          page: this.page,
          gameType: this.gameType,
          sportsId: this.sportsId,
          category: this.category
        }
      },
      statusItem() {
        return this.statusList[this.gameType]
      },
      sportsClassItem() {
        const index = this._.findIndex(this.sportsCategory, {'id': this.sportsId});
        return this.sportsCategory[index]
      },
      sportsMatchList() {
        return this.$store.getters['match/sportsMatchList'];
      },
    },
    watch: {
      sportsMatchList(to){
        this.list =  _.reduce(to, (result, row, key) => {
          if (!result[row['lnm']]) {
            result[row['lnm']] = [];
          }
          result[row['lnm']].push(row)
          return result;
        }, {});
      },
      '$route'(to) {
        let gameType = to.query.gameType.replace('all', '')
        this.gameType = gameType ? gameType : 'pre';
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-create.vue